export const uk = {
    'error-401': 'Нет прав для выполнения данной операции',
    'error-429': 'Превышен лимит запросов. Попробуйте повторить действие позже'
};
